import Components from "../components";

class NestedForm extends Components.Base {
  bind() {
    this.templateHTML = this.$el.find("template[data-new-item]").html();
    this.$addBtn = this.$el.find("[data-add-item]");
    this.$recordList = this.$el.find("[data-item-list]");
    this.$el.find(".remove-item").on("click", this.removeItem.bind(this));

    this.maxItems = parseInt(this.$el.data("max-items"), 10)
    this.toggleAddBtn()

    this.$addBtn.on("click", evt => {
      evt.preventDefault();

      const id = new Date().getTime().toString();
      const newEl = $(this.templateHTML.replace(/NEW_ITEM/g, id));
      this.$recordList.append(newEl);
      newEl.find(".remove-item").on("click", this.removeItem.bind(this));

      Components.collection.loadFragment(newEl);
      this.toggleAddBtn()
    })
  }

  toggleAddBtn() {
    if(this.maxItems) {
      if(this.maxItems > this.$recordList.children().length) {
        this.$addBtn.show()
      } else {
        this.$addBtn.hide()
      }
    }
  }

  removeItem(evt) {
    $(evt.target).parents(".update-form").remove()
    this.toggleAddBtn()
  }
}

Components.collection.register({
  selector: '.c-nested-form',
  klass: NestedForm,
});
